module.exports = __webpack_public_path__ + "img/salvation.36eb7ac3.webp";